module.exports = __webpack_public_path__ + "static/media/male_chat_head.4049eddf.jpg";